import React from 'react';
import { Tooltip } from 'react-tooltip';
import exportConfig from '../../config';

export const CapAlreadyQCdTT = ({ currentCap }) => {
	return (
		<Tooltip id="QCvalue" place="top" effect="solid">
			You have already QC'd this image and determined the state to be{' '}
			<span
				className={`fw-bold ${
					currentCap.newQC === 1
						? 'activeCap'
						: currentCap.newQC === 0
						? 'inactiveCap'
						: 'invalidCap'
				}`}
			>
				{
					exportConfig.qcStates.find(
						(qstate) => qstate.stateInt === currentCap.newQC
					)?.stateString
				}
			</span>
		</Tooltip>
	);
};

export const CapQCdBeforeTT = ({ currentCap }) => {
	return (
		<Tooltip id="QCdBeforevalue" place="top" effect="solid">
			This capture was QC'd on the <span className="fw-bold">{currentCap?.qc_date ? currentCap.qc_date.slice(0,10): 'qc date null'}</span>{' '}
			by <span className="fw-bold">{currentCap?.qc_user ? currentCap.qc_user: 'user'}</span> and was
			determined to be{' '}
			{currentCap.state === 1 ? (
				<span className="fw-bold activeCap">
					{
						exportConfig.qcStates.filter(
							(qstate) => qstate.stateInt === currentCap.state
						)[0].stateString
					}
				</span>
			) : currentCap.state === 0 ? (
				<span className="fw-bold inactiveCap">
					{
						exportConfig.qcStates.filter(
							(qstate) => qstate.stateInt === currentCap.state
						)[0].stateString
					}
				</span>
			) : (
				<span className=" fw-bold invalidCap">
					{
						exportConfig.qcStates.filter(
							(qstate) => qstate.stateInt === currentCap.state
						)[0].stateString
					}
				</span>
			)}
		</Tooltip>
	);
};

export const PreQCTT = ({ currentCap }) => {
	return (
		<Tooltip id="preQCvalue" place="top" effect="solid">
			Pre-QC has determined this capture to be{' '}
			{currentCap.initial_state === 1 ? (
				<span className="fw-bold activeCap">
					{
						exportConfig.qcStates.filter(
							(qstate) => qstate.stateInt === currentCap.initial_state
						)[0].stateString
					}
				</span>
			) : currentCap.initial_state === 0 ? (
				<span className="fw-bold inactiveCap">
					{
						exportConfig.qcStates.filter(
							(qstate) => qstate.stateInt === currentCap.initial_state
						)[0].stateString
					}
				</span>
			) : (
				<span className=" fw-bold invalidCap">
					{
						exportConfig.qcStates.filter(
							(qstate) => qstate.stateInt === currentCap.initial_state
						)[0].stateString
					}
				</span>
			)}
		</Tooltip>
	);
};


export const CapQCdChangingStateTT = ({ selectedRadio }) => {
	return (
		<Tooltip id="captureAlreadyQCd3" place="top" effect="solid">
			capture already QC'd: <strong>change</strong> to{' '}
			{selectedRadio === 1 ? (
				<span className="fw-bold activeCap">
					{
						exportConfig.qcStates.filter(
							(qstate) => qstate.stateInt === selectedRadio
						)[0].stateString
					}
				</span>
			) : selectedRadio === 0 ? (
				<span className="fw-bold inactiveCap">
					{
						exportConfig.qcStates.filter(
							(qstate) => qstate.stateInt === selectedRadio
						)[0].stateString
					}
				</span>
			) : (
				<span className="fw-bold invalidCap">
					{
						exportConfig.qcStates.filter(
							(qstate) => qstate.stateInt === selectedRadio
						)[0].stateString
					}
				</span>
			)}
		</Tooltip>
	);
};

export const CapQCdAgreeingTT = ({ selectedRadio }) => {
	return (
		<Tooltip id="setQCagree" place="top" effect="solid">
			<strong>agree</strong> with pre-QC state{' '}
			{selectedRadio === 1 ? (
				<span className="fw-bold activeCap">
					{
						exportConfig.qcStates.filter(
							(qstate) => qstate.stateInt === selectedRadio
						)[0].stateString
					}
				</span>
			) : selectedRadio === 0 ? (
				<span className="fw-bold inactiveCap">
					{
						exportConfig.qcStates.filter(
							(qstate) => qstate.stateInt === selectedRadio
						)[0].stateString
					}
				</span>
			) : (
				<span className="fw-bold invalidCap">
					{
						exportConfig.qcStates.filter(
							(qstate) => qstate.stateInt === selectedRadio
						)[0].stateString
					}
				</span>
			)}
		</Tooltip>
	);
};

export const CapQCdDisagreeTT = ({ currentCap }) => {
	return (
		<Tooltip id="setQCdisagree" place="top" effect="solid">
			<strong>disagree</strong> with pre-QC state{' '}
			{currentCap.initial_state === 1 ? (
				<span className="fw-bold activeCap">
					{
						exportConfig.qcStates.filter(
							(qstate) => qstate.stateInt === currentCap.initial_state
						)[0].stateString
					}
				</span>
			) : currentCap.initial_state === 0 ? (
				<span className="fw-bold inactiveCap">
					{
						exportConfig.qcStates.filter(
							(qstate) => qstate.stateInt === currentCap.initial_state
						)[0].stateString
					}
				</span>
			) : (
				<span className="fw-bold invalidCap">
					{
						exportConfig.qcStates.filter(
							(qstate) => qstate.stateInt === currentCap.initial_state
						)[0].stateString
					}
				</span>
			)}
		</Tooltip>
	);
};
